import { Injectable } from '@angular/core';
import { TenantGeneralService } from './tenant-general.service';

@Injectable({
  providedIn: 'root',
})
export class TextsService {
  private readonly texts = {
    [this.tenantService.XP_NAME]: {
      welcome:
        'Atinja seu maior potencial de <br /> relacionamento com o mercado <br /> internacional',
      whatsapp: {
        phone: '5511924832608',
        message: 'Olá! Quero mais informações sobre a plataforma de câmbio.',
      },
    },
    [this.tenantService.WARREN_GLOBAL_NAME]: {
      welcome: 'Envie recursos para a Warren Global',
      whatsapp: {
        phone: '554738420136',
        message: 'Olá! Quero mais informações sobre a plataforma de câmbio.',
      },
    },
    [this.tenantService.GALAPAGOS_NAME]: {
      welcome:
        'Atinja seu maior potencial de <br /> relacionamento com o mercado <br /> internacional',
      whatsapp: {
        phone: '5511952130000',
        message: 'Olá! Quero mais informações sobre a plataforma de câmbio.',
      },
    },
    default: {
      welcome:
        'Atinja seu maior potencial de <br /> relacionamento com o mercado <br /> internacional',
      whatsapp: {
        phone: '5511924832608',
        message: 'Olá! Quero mais informações sobre a plataforma de câmbio.',
      },
    },
  };

  constructor(private tenantService: TenantGeneralService) {}

  getText(key: string, tenant: string): string {
    const tenantTexts = this.texts[tenant] || this.texts.default;
    return tenantTexts[key] || this.texts.default[key];
  }

  getWhatsappConfig(tenant: string): { phone: string; message: string } {
    const tenantTexts = this.texts[tenant] || this.texts.default;
    return tenantTexts.whatsapp;
  }
}
